const brookingSortBy = instantsearch.connectors.connectSortBy(
	(renderOptions, isFirstRender) => {
		const {
			options,
			currentRefinement,
			canRefine,
			refine,
			widgetParams,
		  } = renderOptions;

		  if ( ! brookingsAlgoliaFeedOptions.facets.includes('sort') ) {
			return;
		}

		const select = document.querySelector('#sort');

		if (isFirstRender) {	
			document.querySelector('#sortBy').classList.add('active');

			select.addEventListener('change', event => {
				refine(event.target.value);
			});
		}
		
		document.querySelector('#sort').innerHTML = `
			${options.map(
				option => `
				<option value="${option.value}" ${option.value === currentRefinement ? 'selected' : ''}>
				${option.label}
				</option>`
			).join('')}
		`;
	}
);

export default brookingSortBy;